module.exports = __webpack_public_path__ + "static/media/ar.3036121f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ar.svg
// module id = 51
// module chunks = 0